'use client';

import CareersBenefits from './_components/CareersBenefits';
import CareersGallery from './_components/CareersGallery';
import CareersGreenhouseJobBoard from './_components/CareersGreenhouseJobBoard';
import CareersIntro from './_components/CareersIntro';
import CareersOuttro from './_components/CareersOutro';
import CareersTestimonials from './_components/CareersTestimonials';

const Content = () => {
  return (
    <div data-cy="careers-content">
      <CareersIntro />
      <CareersTestimonials />
      <CareersBenefits />
      <CareersGallery />
      <CareersGreenhouseJobBoard />
      <CareersOuttro />
    </div>
  );
};

export default Content;
